<script>
  import { apiFetch } from "../lib/api.js";
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import Navbar from "../components/Navbar.svelte";
    import CardContent from "../components/CardContent.svelte";
    import { user } from "../stores/user";
    import Spinner from "../components/Spinner.svelte";
    import { formatNumber } from "../services/formatNumber";
    import Alert from "../components/Alert.svelte";
    import { BASE_URL } from "../stores/BASE_URL";

    let clientes = [];
    let usuarios = [];
    let modificaciones = [];
    let contratos = [];

    let usuario = {};
    let proximo_contrato = "-";

    let isLoading_modificaciones = false;
    let isLoadingUsuario = false;
    let isSaving = false;

    let modificacion = {
        id_cliente: "0",
        id_usuario: "0",
        tipo: "Nuevo estado",
        "Nuevo estado": {
            nuevo_estado: "1",
            nuevo_plan: null,
            nuevas_consultas_contrato: null,
            nuevas_consultas_masivas: null,
            nuevas_consultas_filtros: null,
        },
        "Nuevo plan": {
            nuevo_estado: null,
            nuevo_plan: "Bronze I",
            nuevas_consultas_contrato: 0,
            nuevas_consultas_masivas: 0,
            nuevas_consultas_filtros: 0,
        },
        "Nueva cantidad de consultas": {
            nuevo_estado: null,
            nuevo_plan: null,
            nuevas_consultas_contrato: 0,
            nuevas_consultas_masivas: 0,
            nuevas_consultas_filtros: 0,
        },
    };

    let disabled_filtros = true;
    let disabled_masivos = true;

    let alert = {
        show: false,
        message: "",
        status: "",
        time: 3000,
    };

    let ver = "TODOS";
    let modificaciones_filtradas = [];

    const getClientes = async () => {
        const response = await apiFetch(`${BASE_URL}cliente.php?action=getClientes`);
        const resp = await response.json();
        clientes = resp.data;
    };

    const getUsuarios = async () => {
        const response = await apiFetch(
            `${BASE_URL}usuario.php?action=getUsuarios&id_cliente=${modificacion.id_cliente}&estado_activo=1&estado_suspendido=2&estado_de_baja=0`,
        );
        const resp = await response.json();
        usuarios = resp.data;
        modificacion.id_usuario = "0";
    };

    const getUsuario = async () => {
        isLoadingUsuario = true;
        const response = await apiFetch(`${BASE_URL}usuario.php?action=getDatos&id=${modificacion.id_usuario}`);
        const resp = await response.json();
        usuario = resp.data;
        usuario.consultas_contrato = formatNumber(usuario.consultas_contrato);
        usuario.consumo = formatNumber(usuario.consumo);
        usuario.consultas_masivas = formatNumber(usuario.consultas_masivas);
        usuario.consultas_filtros = formatNumber(usuario.consultas_filtros);
        isLoadingUsuario = false;
        await getContratos();
        getProximoContrato();
    };

    const getContratos = async () => {
        const response = await apiFetch(`${BASE_URL}usuario.php?action=getContratos&id=${modificacion.id_usuario}`);
        const resp = await response.json();
        contratos = resp.data;
    };

    const getModificaciones = async () => {
        isLoading_modificaciones = true;
        const response = await apiFetch(`${BASE_URL}modificacion.php?action=getModificaciones&estado=TODOS`);
        const resp = await response.json();
        modificaciones = resp.data;
        changeVer();
        isLoading_modificaciones = false;
    };

    const getProximoContrato = () => {
        proximo_contrato = "-";
        if (contratos.length > 0) {
            const tmp_contratos = contratos.filter((c) => c.inicio != usuario.inicio && c.fin != usuario.fin);
            if (tmp_contratos.length > 0) {
                proximo_contrato = tmp_contratos[0];
            }
        }
    };

    const generarPlan = () => {
        disabled_filtros = true;
        disabled_masivos = true;

        modificacion["Nuevo plan"].nuevas_consultas_masivas = "0";
        modificacion["Nuevo plan"].nuevas_consultas_filtros = "0";

        if (
            modificacion["Nuevo plan"].nuevo_plan == "Silver I" ||
            modificacion["Nuevo plan"].nuevo_plan == "Silver II" ||
            modificacion["Nuevo plan"].nuevo_plan == "Gold I" ||
            modificacion["Nuevo plan"].nuevo_plan == "Platinum" ||
            modificacion["Nuevo plan"].nuevo_plan == "Signature" ||
            modificacion["Nuevo plan"].nuevo_plan == "Gold II" ||
            modificacion["Nuevo plan"].nuevo_plan == "Grupal III" ||
            modificacion["Nuevo plan"].nuevo_plan == "Grupal II" ||
            modificacion["Nuevo plan"].nuevo_plan == "Grupal I"
        ) {
            modificacion["Nuevo plan"].nuevas_consultas_masivas = modificacion["Nuevo plan"].nuevas_consultas_contrato;
        } else {
            modificacion["Nuevo plan"].nuevas_consultas_masivas = "0";
        }

        // Filtros
        if (
            modificacion["Nuevo plan"].nuevo_plan == "Gold II" ||
            modificacion["Nuevo plan"].nuevo_plan == "Grupal III" ||
            modificacion["Nuevo plan"].nuevo_plan == "Signature"
        ) {
            modificacion["Nuevo plan"].nuevas_consultas_filtros = modificacion["Nuevo plan"].nuevas_consultas_contrato;
        } else {
            modificacion["Nuevo plan"].nuevas_consultas_filtros = "0";
        }

        // Planes con filtros editables
        if (modificacion["Nuevo plan"].nuevo_plan == "Ilimitado III" || modificacion["Nuevo plan"].nuevo_plan == "Ilimitado IV") {
            disabled_filtros = false;
        }

        // Planes con masivos editables
        if (
            modificacion["Nuevo plan"].nuevo_plan == "Ilimitado II" ||
            modificacion["Nuevo plan"].nuevo_plan == "Ilimitado III" ||
            modificacion["Nuevo plan"].nuevo_plan == "Ilimitado IV"
        ) {
            disabled_masivos = false;
        }
    };

    // ...existing code...
    const generarConsultas = () => {
        disabled_filtros = true;
        disabled_masivos = true;
        modificacion["Nueva cantidad de consultas"].nuevas_consultas_masivas = "0";
        modificacion["Nueva cantidad de consultas"].nuevas_consultas_filtros = "0";

        if (
            usuario.plan == "Silver I" ||
            usuario.plan == "Silver II" ||
            usuario.plan == "Gold I" ||
            usuario.plan == "Platinum" ||
            usuario.plan == "Signature" ||
            usuario.plan == "Gold II" ||
            usuario.plan == "Grupal III" ||
            usuario.plan == "Grupal II" ||
            usuario.plan == "Grupal I"
        ) {
            modificacion["Nueva cantidad de consultas"].nuevas_consultas_masivas = modificacion["Nueva cantidad de consultas"].nuevas_consultas_contrato;
        } else {
            modificacion["Nueva cantidad de consultas"].nuevas_consultas_masivas = "0";
        }

        // Filtros
        if (
            usuario.plan == "Gold II" ||
            usuario.plan == "Grupal III" ||
            usuario.plan == "Signature" ||
            usuario.plan == "Ilimitado III" ||
            usuario.plan == "Ilimitado IV"
        ) {
            modificacion["Nueva cantidad de consultas"].nuevas_consultas_filtros = modificacion["Nueva cantidad de consultas"].nuevas_consultas_contrato;
        } else {
            modificacion["Nueva cantidad de consultas"].nuevas_consultas_filtros = "0";
        }

        // Planes con filtros editables
        if (usuario.plan == "Ilimitado III" || usuario.plan == "Ilimitado IV") {
            disabled_filtros = false;
        }

        // Planes con masivos editables
        if (usuario.plan == "Ilimitado II" || usuario.plan == "Ilimitado III" || usuario.plan == "Ilimitado IV") {
            disabled_masivos = false;
        }
    };
    // ...existing code...

    const validarPlan = () => {
        let validate = true;
        if (modificacion["Nuevo plan"] == "API") {
            alert("No se puede generar el plan API");
            validate = false;
        }

        return validate;
    };

    const deleteModificacion = async (id) => {
        if (!confirm("¿Está seguro que desea eliminar esta modificación?")) {
            return;
        }

        alert.show = false;
        const formData = new FormData();
        formData.append("id", id);
        formData.append("action", "deleteModificacion");
        const response = await apiFetch(`${BASE_URL}modificacion.php`, {
            method: "POST",
            body: formData,
        });

        const resp = await response.json();
        if (resp.status === "success") {
            alert.show = true;
            alert.message = "Modificación eliminada correctamente";
            alert.status = "success";
            getModificaciones();
        } else {
            alert.show = true;
            alert.message = resp.message || "Error al eliminar la modificación";
            alert.status = "danger";
        }
    };

    const changeUsuario = async () => {
        if (modificacion.id_usuario != "0") {
            await getUsuario();
            switch (modificacion.tipo) {
                case "Nuevo estado":
                    modificacion["Nuevo estado"].nuevo_estado = "1";
                    break;
                case "Nuevo plan":
                    modificacion["Nuevo plan"].nuevo_plan = "Bronze I";
                    modificacion["Nuevo plan"].nuevas_consultas_contrato = 0;
                    modificacion["Nuevo plan"].nuevas_consultas_masivas = 0;
                    modificacion["Nuevo plan"].nuevas_consultas_filtros = 0;
                    generarPlan();
                    break;
                case "Nueva cantidad de consultas":
                    modificacion["Nueva cantidad de consultas"].nuevas_consultas_contrato = 0;
                    modificacion["Nueva cantidad de consultas"].nuevas_consultas_masivas = 0;
                    modificacion["Nueva cantidad de consultas"].nuevas_consultas_filtros = 0;
                    generarConsultas();
                    break;
            }
        }
    };

    const changeTipo = () => {
        switch (modificacion.tipo) {
            case "Nuevo estado":
                modificacion["Nuevo estado"].nuevo_estado = "1";
                break;
            case "Nuevo plan":
                modificacion["Nuevo plan"].nuevo_plan = "Bronze I";
                modificacion["Nuevo plan"].nuevas_consultas_contrato = 0;
                modificacion["Nuevo plan"].nuevas_consultas_masivas = 0;
                modificacion["Nuevo plan"].nuevas_consultas_filtros = 0;
                generarPlan();
                break;
            case "Nueva cantidad de consultas":
                modificacion["Nueva cantidad de consultas"].nuevas_consultas_contrato = 0;
                modificacion["Nueva cantidad de consultas"].nuevas_consultas_masivas = 0;
                modificacion["Nueva cantidad de consultas"].nuevas_consultas_filtros = 0;
                generarConsultas();
                break;
        }
    };

    const changeVer = () => {
        if (ver == "TODOS") {
            modificaciones_filtradas = modificaciones;
        } else {
            modificaciones_filtradas = modificaciones.filter((m) => m.estado == ver);
        }
    };

    const saveModificacion = async () => {
        const tmp_modificacion = {
            id_cliente: modificacion.id_cliente,
            id_usuario: modificacion.id_usuario,
            tipo: modificacion.tipo,
            inicio: proximo_contrato.inicio,
            fin: proximo_contrato.fin,
            nuevo_estado: modificacion[modificacion.tipo].nuevo_estado,
            nuevo_plan: modificacion[modificacion.tipo].nuevo_plan,
            nuevas_consultas_contrato:
                modificacion[modificacion.tipo].nuevas_consultas_contrato == null
                    ? null
                    : modificacion[modificacion.tipo].nuevas_consultas_contrato.replace(/[^\d.]/g, ""),
            nuevas_consultas_masivas:
                modificacion[modificacion.tipo].nuevas_consultas_masivas == null ? null : modificacion[modificacion.tipo].nuevas_consultas_masivas.replace(/[^\d.]/g, ""),
            nuevas_consultas_filtros:
                modificacion[modificacion.tipo].nuevas_consultas_filtros == null ? null : modificacion[modificacion.tipo].nuevas_consultas_filtros.replace(/[^\d.]/g, ""),
        };
        isSaving = true;

        const response = await apiFetch(`${BASE_URL}modificacion.php`, {
            method: "POST",
            body: JSON.stringify(tmp_modificacion),
            headers: {
                "Content-Type": "aplication/json",
            },
        });

        const resp = await response.json();
        isSaving = false;
        if (resp.status === "success") {
            alert.show = true;
            alert.message = "Modificación registrada correctamente";
            alert.status = "success";
            setTimeout(() => {
                alert.show = false;
            }, alert.time);
            getModificaciones();
        } else {
            alert.show = true;
            alert.message = resp.message || "Error al registrar la modificación";
            alert.status = "danger";
            setTimeout(() => {
                alert.show = false;
            }, alert.time);
        }
    };

    const handlePlanNuevasConsultas = (event) => {
        const formattedValue = formatNumber(event.target.value);
        modificacion["Nuevo plan"].nuevas_consultas_contrato = formattedValue;
        generarPlan();
    };

    const handlePlanNuevasConsultasMasivas = (event) => {
        const formattedValue = formatNumber(event.target.value);
        modificacion["Nuevo plan"].nuevas_consultas_masivas = formattedValue;
    };

    const handlePlanNuevasConsultasFiltros = (event) => {
        const formattedValue = formatNumber(event.target.value);
        modificacion["Nuevo plan"].nuevas_consultas_filtros = formattedValue;
    };

    const handleNuevasConsultas = (event) => {
        const formattedValue = formatNumber(event.target.value);
        modificacion["Nueva cantidad de consultas"].nuevas_consultas_contrato = formattedValue;
        generarConsultas();
    };

    const handleNuevasConsultasMasivas = (event) => {
        const formattedValue = formatNumber(event.target.value);
        modificacion["Nueva cantidad de consultas"].nuevas_consultas_masivas = formattedValue;
    };

    const handleNuevasConsultasFiltros = (event) => {
        const formattedValue = formatNumber(event.target.value);
        modificacion["Nueva cantidad de consultas"].nuevas_consultas_filtros = formattedValue;
    };

    getClientes();
    getModificaciones();

    onMount(() => {
        if (!$user) {
            navigate("/", { replace: true });
        }
    });
</script>

{#if $user}
    <Navbar />

    <div class="container-fluid py-3">
        <CardContent title="Modificaciones futuras">
            <div class="row g-2 mb-3">
                <div class="col-12 col-sm-12 col-md-6 col-lg-2">
                    <label for="ver" class="form-label text-secondary">Ver</label>
                    <select class="form-select" id="ver" bind:value={ver} on:change={changeVer}>
                        <option value="TODOS">TODOS</option>
                        <option value="1">PENDIENTES</option>
                        <option value="0">EJECUTADOS</option>
                    </select>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-2">
                    <label for="tipo" class="form-label text-secondary">Tipo de modificación</label>
                    <select class="form-select" id="tipo" bind:value={modificacion.tipo} on:change={changeTipo}>
                        <option value="Nuevo estado">Nuevo estado</option>
                        <option value="Nuevo plan">Nuevo Plan</option>
                        <option value="Nueva cantidad de consultas">Nueva cantidad de consultas</option>
                    </select>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-5">
                    <label for="cliente" class="form-label text-secondary">Cliente</label>
                    <select class="form-select" id="cliente" bind:value={modificacion.id_cliente} on:change={getUsuarios}>
                        <option value="0">SELECCIONAR CLIENTE</option>
                        {#each clientes as cliente}
                            <option value={cliente.id}>{cliente.razon_social}</option>
                        {/each}
                    </select>
                </div>
                <div class="col-12 col-sm-12 col-md-6 col-lg-3">
                    <label for="usuario" class="form-label text-secondary">Usuario</label>
                    <select class="form-select" id="usuario" bind:value={modificacion.id_usuario} on:change={changeUsuario}>
                        <option value="0">SELECCIONAR USUARIO</option>
                        {#each usuarios as usuario}
                            <option value={usuario.id}>{usuario.usuario}</option>
                        {/each}
                    </select>
                </div>
            </div>

            {#if modificacion.id_usuario != "0"}
                {#if isLoadingUsuario}
                    <Spinner message="Cargando usuario" />
                {:else}
                    <div class="card mb-3">
                        <div class="card-body">
                            <h5 class="card-title text-secondary fs-6">Contrato actual del cliente</h5>
                            <div class="table-responsive">
                                <table class="table table-sm table-striped small">
                                    <tbody>
                                        <tr>
                                            <th class="text-secondary fw-normal">Estado</th>
                                            <td>
                                                {#if usuario.estado == "1"}
                                                    <small
                                                        class="d-inline-flex px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2"
                                                    >
                                                        Activo
                                                    </small>
                                                {:else if usuario.estado == "2"}
                                                    <small
                                                        class="d-inline-flex px-2 fw-semibold text-danger bg-danger bg-opacity-10 border border-danger border-opacity-10 rounded-2"
                                                    >
                                                        Suspendido
                                                    </small>
                                                {:else}
                                                    <small
                                                        class="d-inline-flex px-2 fw-semibold text-dark bg-dark bg-opacity-10 border border-dark border-opacity-10 rounded-2"
                                                    >
                                                        De baja
                                                    </small>
                                                {/if}
                                            </td>
                                            <th class="text-secondary fw-normal">Plan</th>
                                            <td>{usuario.plan}</td>
                                        </tr>
                                        <tr>
                                            <th class="text-secondary fw-normal">Consultas contrato</th>
                                            <td>{usuario.consultas_contrato}</td>
                                            <th class="text-secondary fw-normal">Consultas masivas</th>
                                            <td>{usuario.consultas_masivas}</td>
                                        </tr>
                                        <tr>
                                            <th class="text-secondary fw-normal">Consultas filtros</th>
                                            <td>{usuario.consultas_filtros}</td>
                                            <th class="text-secondary fw-normal">Proximo contrato</th>
                                            {#if proximo_contrato != "-"}
                                                <td>{proximo_contrato.inicio} <b> - </b> {proximo_contrato.fin}</td>
                                            {:else}
                                                <td> No tiene un próximo contrato </td>
                                            {/if}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {#if modificacion.tipo == "Nuevo estado"}
                        <div class="alert alert-danger mb-3">
                            <div class="row g2">
                                <div class="col-12 col-md-6 col-lg-3">
                                    <label for="nuevo_estado" class="form-label">Nuevo estado</label>
                                    <select class="form-select" id="nuevo_estado" bind:value={modificacion["Nuevo estado"].nuevo_estado}>
                                        <option value="1">Activo</option>
                                        <option value="2">Suspendido</option>
                                        <option value="0">De baja</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    {:else if modificacion.tipo == "Nuevo plan"}
                        <div class="alert alert-warning mb-3">
                            <div class="row g-2">
                                <div class="col-12 col-md-6 col-lg-3">
                                    <label for="plan" class="form-label">Nuevo plan</label>
                                    <select class="form-select" id="plan" bind:value={modificacion["Nuevo plan"].nuevo_plan} on:change={generarPlan}>
                                        <option value="Bronze I">Bronze I</option>
                                        <option value="Bronze II">Bronze II</option>
                                        <option value="Silver I">Silver I</option>
                                        <option value="Silver II">Silver II </option>
                                        <option value="Gold I">Gold I</option>
                                        <option value="Gold II">Gold II</option>
                                        <option value="Platinum">Platinum</option>
                                        <option value="Signature">Signature</option>
                                        <option value="Ilimitado I">Ilimitado I</option>
                                        <option value="Ilimitado II">Ilimitado II</option>
                                        <option value="Ilimitado III">Ilimitado III</option>
                                        <option value="Ilimitado IV">Ilimitado IV</option>
                                        <option value="Grupal III">Grupal III</option>
                                        <option value="Grupal II">Grupal II</option>
                                        <option value="Grupal I">Grupal I</option>
                                        <option value="API" disabled>API</option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-6 col-lg-3">
                                    <label for="plan_consultas_contrato" class="form-label">Consultas contratadas</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="plan_consultas_contrato"
                                        bind:value={modificacion["Nuevo plan"].nuevas_consultas_contrato}
                                        on:input={handlePlanNuevasConsultas}
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-3">
                                    <label for="plan_consultas_masivas" class="form-label">Cant. Masivos</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="plan_consultas_masivas"
                                        bind:value={modificacion["Nuevo plan"].nuevas_consultas_masivas}
                                        on:input={handlePlanNuevasConsultasMasivas}
                                        disabled={disabled_masivos}
                                    />
                                </div>
                                <div class="col-12 col-md-6 col-lg-3">
                                    <label for="plan_filtros" class="form-label">Cant. Filtros</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="plan_filtros"
                                        bind:value={modificacion["Nuevo plan"].nuevas_consultas_filtros}
                                        on:input={handlePlanNuevasConsultasFiltros}
                                        disabled={disabled_filtros}
                                    />
                                </div>
                            </div>
                        </div>
                    {:else if modificacion.tipo == "Nueva cantidad de consultas"}
                        <div class="alert alert-primary mb-3">
                            <div class="row g-2">
                                <div class="col-12 col-sm-12 col-md-6 col-lg-3">
                                    <label for="consultas" class="form-label">Nueva cantidad de consultas</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="consultas"
                                        bind:value={modificacion["Nueva cantidad de consultas"].nuevas_consultas_contrato}
                                        on:input={handleNuevasConsultas}
                                    />
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 col-lg-3">
                                    <label for="consultas_masivas" class="form-label">Cant. Masivos</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="consultas_masivas"
                                        bind:value={modificacion["Nueva cantidad de consultas"].nuevas_consultas_masivas}
                                        on:input={handleNuevasConsultasMasivas}
                                        disabled={disabled_masivos}
                                    />
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 col-lg-3">
                                    <label for="consultas_filtros" class="form-label">Cant. Filtros</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="consultas_filtros"
                                        bind:value={modificacion["Nueva cantidad de consultas"].nuevas_consultas_filtros}
                                        on:input={handleNuevasConsultasFiltros}
                                        disabled={disabled_filtros}
                                    />
                                </div>
                            </div>
                        </div>
                    {/if}

                    <div class="row mb-3">
                        <div class="col-12 text-end">
                            {#if isSaving}
                                <button class="btn btn-primary" disabled>Registrando...</button>
                            {:else}
                                <button class="btn btn-primary" disabled={proximo_contrato == "-" || modificacion.id_usuario == "0"} on:click={saveModificacion}>
                                    Registrar cambio
                                </button>
                            {/if}
                        </div>
                    </div>
                {/if}
            {/if}

            {#if alert.show}
                <Alert message={alert.message} status={alert.status} time={alert.time} />
            {/if}

            <div class="table-responsive">
                <table class="table table-sm table-striped table-bordered small">
                    <thead>
                        <tr class="text-secondary fw-normal">
                            <th>Cliente</th>
                            <th>Usuario</th>
                            <th>Fecha de registro</th>
                            <th>Tipo</th>
                            <th>Nuevo estado</th>
                            <th>Nuevo plan</th>
                            <th>Nuevas consultas</th>
                            <th>Cant. Masivos</th>
                            <th>Cant. Filtros</th>
                            <th>Inicio</th>
                            <th>Fin</th>
                            <th>Estado</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {#if isLoading_modificaciones}
                            <tr>
                                <td colspan="13">
                                    <Spinner message="Cargando" />
                                </td>
                            </tr>
                        {:else}
                            {#each modificaciones_filtradas as m}
                                <tr>
                                    <td>{m.razon_social}</td>
                                    <td>{m.usuario}</td>
                                    <td>{m.fecha_registro}</td>
                                    <td class={m.tipo == "Nuevo plan" ? "table-warning" : m.tipo == "Nuevo estado" ? "table-danger" : "table-primary"}>{m.tipo}</td>
                                    <td>
                                        {#if m.nuevo_estado == "1"}
                                            <small
                                                class="d-inline-flex px-2 fw-semibold text-success bg-success bg-opacity-10 border border-success border-opacity-10 rounded-2"
                                            >
                                                Activo
                                            </small>
                                        {:else if m.nuevo_estado == "2"}
                                            <small
                                                class="d-inline-flex px-2 fw-semibold text-danger bg-danger bg-opacity-10 border border-danger border-opacity-10 rounded-2"
                                            >
                                                Suspendido
                                            </small>
                                        {:else if m.nuevo_estado == "0"}
                                            <small class="d-inline-flex px-2 fw-semibold text-dark bg-dark bg-opacity-10 border border-dark border-opacity-10 rounded-2">
                                                De baja
                                            </small>
                                        {/if}
                                    </td>
                                    <td>{m.nuevo_plan ?? ""}</td>
                                    <td class="text-end">{m.nuevas_consultas_contrato == null ? "" : formatNumber(m.nuevas_consultas_contrato)}</td>
                                    <td class="text-end">{m.nuevas_consultas_masivas == null ? "" : formatNumber(m.nuevas_consultas_masivas)}</td>
                                    <td class="text-end">{m.nuevas_consultas_filtros == null ? "" : formatNumber(m.nuevas_consultas_filtros)}</td>
                                    <td>{m.inicio}</td>
                                    <td>{m.fin}</td>
                                    <td>
                                        {#if m.estado == "1"}
                                            PENDIENTE
                                        {:else}
                                            EJECUTADO
                                        {/if}
                                    </td>

                                    <td class="text-center">
                                        {#if m.estado == "1"}
                                            <button class="btn btn-danger btn-sm py-0 px-1" on:click={() => deleteModificacion(m.id)}> <i class="bi bi-trash" /> </button>
                                        {/if}
                                    </td>
                                </tr>
                            {:else}
                                <tr>
                                    <td colspan="13" class="text-center text-secondary"> · · · No se encontraron resultados · · · </td>
                                </tr>
                            {/each}
                        {/if}
                    </tbody>
                </table>
            </div>
        </CardContent>
    </div>
{/if}
